(function () {
  var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motionQuery && motionQuery.matches) return;

  var root = document.documentElement;
  if (!root.classList.contains('homepage-reveal-ready')) return;

  var main = document.getElementById('MainContent');
  if (!main) {
    root.classList.remove('homepage-reveal-ready');
    return;
  }

  var sectionSelector = ':scope > .shopify-section';
  var childSelectors = [
    '.homepage-account-prompt__inner',
    '.title-wrapper-with-link',
    '.featured-collection__heading',
    '.product-grid > .grid__item',
    '.collection .grid__item',
    '.auction-homepage__header',
    '[id^="_a-featured-auctions-"] ._a-grid-div-item',
    '.habitat-banner__inner',
    '.rich-text__blocks > *',
    '.multicolumn-list__item',
    '.card-wrapper'
  ].join(',');

  function isElementVisible(element) {
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function shouldRevealSection(section) {
    if (!isElementVisible(section)) return false;
    if (section.querySelector('.hero-slider')) return false;
    if (section.id && /hero_slider/i.test(section.id)) return false;

    return true;
  }

  function getRevealPriority(section) {
    var priorityElement = section.querySelector('[data-homepage-reveal-priority]');
    return priorityElement ? priorityElement.getAttribute('data-homepage-reveal-priority') : '';
  }

  function isEarlyRevealSection(section) {
    return getRevealPriority(section) === 'early';
  }

  function isInitiallyVisible(section) {
    var rect = section.getBoundingClientRect();
    var viewportMultiplier = isEarlyRevealSection(section) ? 1.45 : 0.92;
    return rect.top < window.innerHeight * viewportMultiplier;
  }

  function applyChildStagger(section) {
    var isEarlyReveal = isEarlyRevealSection(section);
    var delayStep = isEarlyReveal ? 35 : 55;
    var maxDelay = isEarlyReveal ? 260 : 420;
    var children = Array.prototype.slice.call(section.querySelectorAll(childSelectors))
      .filter(function (child) {
        return isElementVisible(child) && !child.closest('.hero-slider');
      })
      .slice(0, 18);

    children.forEach(function (child, index) {
      child.setAttribute('data-homepage-reveal-child', '');
      child.style.setProperty('--homepage-reveal-delay', Math.min(index * delayStep, maxDelay) + 'ms');
    });
  }

  function getInitialRevealDelay(section, index) {
    if (isEarlyRevealSection(section)) return 70;
    return 140 + index * 120;
  }

  function reveal(section, observer) {
    section.classList.add('is-visible');
    if (observer) observer.unobserve(section);
  }

  var sections = Array.prototype.slice.call(main.querySelectorAll(sectionSelector)).filter(shouldRevealSection);
  if (!sections.length) {
    root.classList.remove('homepage-reveal-ready');
    return;
  }

  var initiallyVisibleSections = [];

  sections.forEach(function (section) {
    section.setAttribute('data-homepage-reveal', '');
    applyChildStagger(section);

    if (isInitiallyVisible(section)) {
      initiallyVisibleSections.push(section);
    }
  });

  root.classList.add('homepage-reveal-ready', 'homepage-reveal-has-run');

  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      initiallyVisibleSections.forEach(function (section, index) {
        window.setTimeout(function () {
          reveal(section);
        }, getInitialRevealDelay(section, index));
      });
    });
  });

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (section) {
      reveal(section);
    });
    return;
  }

  var observerCallback = function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target, observer);
      }
    });
  };

  var observer = new IntersectionObserver(observerCallback, {
    rootMargin: '0px 0px -12% 0px',
    threshold: 0.12
  });

  var earlyObserver = new IntersectionObserver(observerCallback, {
    rootMargin: '0px 0px 45% 0px',
    threshold: 0.01
  });

  sections.forEach(function (section) {
    if (!section.classList.contains('is-visible') && initiallyVisibleSections.indexOf(section) === -1) {
      if (isEarlyRevealSection(section)) {
        earlyObserver.observe(section);
      } else {
        observer.observe(section);
      }
    }
  });

  if ('MutationObserver' in window) {
    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var section = mutation.target.closest && mutation.target.closest('[data-homepage-reveal]');
        if (section) applyChildStagger(section);
      });
    });

    sections.forEach(function (section) {
      mutationObserver.observe(section, { childList: true, subtree: true });
    });
  }
})();
